let apps = []
switch (process.env.VUE_APP_CURENV) {
    case "test":
        apps = require('./test')
        break;
    case "development":
        apps = require('./development')
        break;
    case "production":
        apps = require('./production')
        break;
}
console.log('apps', apps)
export default apps